"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));

var React = _interopRequireWildcard(require("react"));

var _Eye = _interopRequireDefault(require("@bedrock/icons-svg/lib/asn/Eye"));

var _RockIcon = _interopRequireDefault(require("../components/RockIcon"));

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var Eye = function Eye(props, ref) {
  return /*#__PURE__*/React.createElement(_RockIcon.default, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
    ref: ref,
    icon: _Eye.default
  }));
};

Eye.displayName = 'Eye';

var _default = /*#__PURE__*/React.forwardRef(Eye);

exports.default = _default;